<script>
import ModuleTitle from '../common/ModuleTitle.vue'

export default {
  name: 'Comp1',
  components: { ModuleTitle },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  }
}
</script>

<template>
  <div class="modules-id-1"><!-- v-if="moduleOption.list && moduleOption.list.length > 0" -->
    <module-title :title="moduleOption.title" margin-bottom="20" />
    <div class="comp-transverse-3 modules-id-1-content pointer">
      <div v-for="v in moduleOption.list.slice(0, 6)" :key="`modules-1-${v.id}`" class="item">
        <el-image class="avator" :src="v.photo | imgPath" alt="avator" fit="cover" />
        <p class="name">{{ v.name || '' }}</p>
        <p class="post">{{ v.post || '' }}</p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-1-content {
  display: flex;
  flex-wrap: wrap;
  // display: grid;
  // grid-template-columns: repeat(auto-fill, 151px);
  row-gap: 30px;
  column-gap: 100px;
  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: wrap;
  }
  .avator {
    width: 80px;
    height: 99px;
  }
  .name, .post {
    width: 85px;
    font-size: 15px;
    font-weight: bold;
    color: #000;
    text-align: center;
  }
  .name {
    margin-top: 8px;
  }
  .post {
    margin-top: 4px;
  }
}
</style>
